import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import ReusableCheckBox from "../../Configuration/ReusableComponents/ReusableCheckBox";
import {
  useAddOutletTypes,
  useOutletTypeList,
  useUpdateOutletType,
} from "../MastersScreen/hooks/useSettingsMasters";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { showToast } from "../../../utils/toastUtils";

interface OutletTypeTableModalContentProps {
  handleClose: () => void;
  isModalStatus: string;
  selectedRow: any;
  outletTypeId: string | number;
}

const OutletTypeTableModalContent: React.FC<
  OutletTypeTableModalContentProps
> = ({ handleClose, isModalStatus, selectedRow, outletTypeId }) => {
  const [formValues, setFormValues] = useState<string | number | boolean | any>(
    {
      isEnabled: false,
      isEndCustomer: false,
      isPrimary: false,
      name: "",
      parent: "",
      orgunit: [],
    }
  );

  const { mutate: updateOutletTypes } = useUpdateOutletType();
  const { mutate: addOutletTypes } = useAddOutletTypes();
  const { data: outletTypeData } = useOutletTypeList({ enable: true });
  const { data: orgUnitsData, isLoading: orgUnitLoading } = useGetOrgUnitsData({
    enable: true,
  });

  const formattedOrgUnitData = Object.entries(orgUnitsData?.data || {}).map(
    (item: any) => ({
      id: item[0],
      label: item[1],
    })
  );

  const formattedParentData = [
    { id: 0, label: "None" },
    ...(outletTypeData?.data?.map((item: any) => ({
      id: item?.OutlettypeId,
      label: item?.OutlettypeName,
    })) || []),
  ];

  useEffect(() => {
    if (selectedRow && isModalStatus === "Edit") {
      const selectedOrgUnits = selectedRow?.OrgUnitId.split(",")
        .map((id: string) => {
          const matchedUnit = formattedOrgUnitData.find(
            (unit: any) => Number(unit.id) === Number(id)
          );
          return matchedUnit
            ? { id: Number(id), name: matchedUnit.label }
            : null;
        })
        .filter(Boolean);

      setFormValues({
        isEnabled: Number(selectedRow?.Isenabled) === 1,
        isEndCustomer: Number(selectedRow?.Isoutletendcustomer) === 1,
        isPrimary: Number(selectedRow?.Isoutletprimary) === 1,
        name: selectedRow?.OutlettypeName || "",
        parent: selectedRow?.OutlettypeId,
        orgunit: selectedOrgUnits || [],
      });
    }
  }, [selectedRow]);

  const handleCheckboxChange = (field: string, checked: boolean) => {
    setFormValues((prev: any) => ({
      ...prev,
      [field]: checked,
    }));
  };

  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleMultiSelectChange = (selectedValues: string[] | number[]) => {
    const selectedData = selectedValues.map((id) =>
      formattedOrgUnitData.find((unit: any) => unit.id == id)
    );

    setFormValues((prevState: any) => ({
      ...prevState,
      orgunit: selectedData.filter(Boolean),
    }));
  };

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;
    const numericFields = ["mobile", "registration"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setFormValues((prevState: any) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  const handleSubmit = (formValues: any) => {
    if (isModalStatus === "Edit" && selectedRow) {
      const updateOutletTypeBody = {
        OutlettypeName: formValues?.name,
        Outletparent: formValues?.parent,
        Isoutletprimary: formValues?.isPrimary === true ? 1 : 0,
        isOutletEndCustomer: formValues?.isEndCustomer === true ? 1 : 0,
        isEnabled: formValues?.isEnabled === true ? 1 : 0,
        OrgUnitId: formValues?.orgunit,
      };

      updateOutletTypes(
        { id: outletTypeId, body: updateOutletTypeBody },
        {
          onSuccess: () => {
            handleClose();
            setFormValues({
              isEnabled: "",
              isEndCustomer: "",
              isPrimary: "",
              name: "",
              parent: "",
              orgunit: [],
            });
          },
          onSettled: () => {
            handleClose();
            setFormValues({
              isEnabled: "",
              isEndCustomer: "",
              isPrimary: "",
              name: "",
              parent: "",
              orgunit: [],
            });
          },
        }
      );
    } else {
      const addOutletTypeBody = {
        OutlettypeName: formValues?.name,
        Outletparent: formValues?.parent,
        Isoutletprimary: formValues?.isPrimary === true ? 1 : 0,
        isOutletEndCustomer: formValues?.isEndCustomer === true ? 1 : 0,
        isEnabled: formValues?.isEnabled === true ? 1 : 0,
        OrgUnitId: formValues?.orgunit,
      };
       
      if(formValues.name !=""){
      addOutletTypes(addOutletTypeBody, {
        onSuccess: () => {
          handleClose();
          setFormValues({
            isEnabled: "",
            isEndCustomer: "",
            isPrimary: "",
            name: "",
            parent: "",
            orgunit: [],
          });
        },
        onSettled: () => {
          handleClose();
          setFormValues({
            isEnabled: "",
            isEndCustomer: "",
            isPrimary: "",
            name: "",
            parent: "",
            orgunit: [],
          });
        },
      });
      }
      else{
        showToast.warning('fill the Mandatory Field')
      }
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <CustomInput
           style={{borderRadius:'4px'}}
            label="Name"
            required
            asterisk
            placeholder="Enter Name"
            type="text"
            name="name"
            value={formValues?.name}
            onChange={(e) => handleInputChange("name", e)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <ReusableDropdown
            options={formattedParentData || []}
            onChange={(value: any) => {
              handleDropdownSelect("parent", value);
            }}
            DropdownHeading="Parent"
            value={formValues?.parent}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <ReusableDropdown
            options={formattedOrgUnitData || []}
            isMulti={true}
            onChange={(value: any) => {
              handleMultiSelectChange(value);
            }}
            // value={formValues?.orgunit}
            value={formValues?.orgunit.map((unit: any) => unit.id.toString())}
            DropdownHeading="Org Unit"
            placeholder="Select Org Unit "
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <ReusableCheckBox
            data={[
              {
                label: "Is End Customer",
                value: "active",
                checked: formValues.isEndCustomer, // <-- bind to formValues
              },
            ]}
            onCheckedChange={(checkedItems) =>
              handleCheckboxChange(
                "isEndCustomer",
                checkedItems.includes("active")
              )
            }
          />
        </div>
        <div className="col-md-4">
          <ReusableCheckBox
            data={[
              {
                label: "Is Primary",
                value: "active",
                checked: formValues.isPrimary, // <-- bind to formValues
              },
            ]}
            onCheckedChange={(checkedItems) =>
              handleCheckboxChange("isPrimary", checkedItems.includes("active"))
            }
          />
        </div>
        <div className="col-md-4">
          <ReusableCheckBox
            data={[
              {
                label: "Is Enabled",
                value: "active",
                checked: formValues.isEnabled, // <-- bind to formValues
              },
            ]}
            onCheckedChange={(checkedItems) =>
              handleCheckboxChange("isEnabled", checkedItems.includes("active"))
            }
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          onClick={() => {
            handleSubmit({
              ...formValues,
              orgunit: formValues?.orgunit.map((item: any) => item.id),
            });
          }}
        >
          Submit
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </div>
  );
};

export default OutletTypeTableModalContent;
